import axios from ".././axios-interceptor";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { Modal, Table } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { toast } from "react-toastify";
import {
    STATUS_NEW,
    STATUS_IN_PROGRESS,
    STATUS_APPROVED,
    STATUS_REJECTED,
    STATUS_PROCESSED,
    base_url,
    SERVICE_REQUEST_NEW_LOAN,
    SERVICE_REQUEST_EXTEND_TENURE,
    SERVICE_REQUEST_PRE_CLOSURE,
    SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
    LOAN_REPAYMENT_BY_BUSINESS,
    STATUS_CLOSED,
} from "../utilities";
import Cookies from 'js-cookie';
import { LOAN_CURRENCY_TYPE_BHD, LOAN_CURRENCY_TYPE_USD } from "./../utilities";
import { Navigate, useNavigate } from "react-router-dom";
window.Buffer = window.Buffer || require("buffer").Buffer;

const ServiceRequestsTerms = (props) => {
  const navigate = useNavigate();
  if (!Cookies.get("User_Accesstoken_Business")) {
    navigate('/');
  }
  let loading =props.loading;
  let loan_history_array = [];
  const [activeTab, setActiveTab] = useState("home-tab");

  props.data.loan_history?.map(each_history_record => {
    //NEW LOAN REQUEST LIST
    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business requested loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if((!each_history_record.is_investor_interested) && (!each_history_record.is_admin_sent_terms_to_business)){
    if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Admin filled the profit percentage and sent to investors";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
  }
    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Admin rejected the new loan request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.is_investor_interested===1 && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Investor has shown interest on this loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.is_admin_sent_terms_to_business===1 && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Admin sent loan terms and awaiting for business response";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }

    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business agreed the new loan request terms";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }

    if (each_history_record.status == STATUS_PROCESSED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = (
        <div className='style_loan_txt'>
          Admin paid the requested loan amount <span style={{color:"black",marginTop:"2px" }} className="ps-1 pe-1 fw-bold">{each_history_record.paid_currency +" "+ Number(each_history_record.paid_amount).toLocaleString() }</span> to business on <span style={{color:"black",marginTop:"2px"}} className="ps-1 pe-1 fw-bold">{ moment(each_history_record.paid_date).format('DD MMM YYYY')}</span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == LOAN_REPAYMENT_BY_BUSINESS && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = 
      <div className=''>
              Business repaid for the month of <span style={{color:"black"}} className="fw-bold">{moment(each_history_record.tenure_date).format('MMMM')}</span>, loan tenure amount <span style={{color:"black"}} className="fw-bold">{ each_history_record.paid_currency +" "+ Number(each_history_record.paid_amount).toLocaleString()}</span> to admin on <span style={{color:"black"}} className=" fw-bold">{moment(each_history_record.paid_date).format('DD MMM YYYY')}</span>
            </div>
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Business requested to extend loan tenure";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Admin approved extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Admin rejected the extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Business requested for pre closure of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Admin approved pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Admin rejected pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Business requested for partial pre-payment of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin approved partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin rejected partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (each_history_record.status == STATUS_CLOSED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business repaid the loan successfully"
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
  })
  
  useEffect(() => {
    axios
      .post(base_url + "loan-trx/get_loan_trx_user", {
        user_id: Cookies.get("user_id"),
      })
      .then((res) => {
        const data = res.data.data;
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  if (props.data.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
    props.data.service_type_name = "New Loan";
  }
  if (props.data.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
    props.data.service_type_name = "Extend Tenure";
  }
  if (props.data.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
    props.data.service_type_name = "Pre Closure";
  }
  const handleClose = () => {
    props.onHide();
    setActiveTab('home-tab')
  };

  const handleSavechanges = () => {
    //hit the api from rejection api here
    let business_agree_obj = {
      investor_interest_id: props.data.investor_interest_id,
      investor_id: props.data.investor_id,
      service_request_id: props.data.service_request_id,
      loan_id: props.data.loan_id,
      admin_request_loan_tenure: props.data.admin_request_loan_tenure,
      admin_request_loan_currency: props.data.admin_request_loan_currency,
      admin_request_loan_amount: props.data.loan_amount,
      bennefin_roi: props.data.bennefin_roi,
      investor_roi: props.data.investor_roi,
      principal_frequency: props.data.principal_frequency,
      interest_frequency: props.data.interest_frequency,
    };
    axios
      .post(
        base_url + "service-request-trx/save_business_agreed_terms",
        business_agree_obj
      )
      .then((res) => {
        if (res.data.status == 200) {
          toast.success("Success", {
            toastId: 4,
          });
            props.onHide();
          setTimeout(() => {
            window.location.reload();
          },800);
        }
      });
  };
  return (
    <>
      <Modal
        {...props}
        dialogClassName="modal-190w"
        aria-labelledby="example-custom-modal-styling-title"
        size="lg"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          onHide={handleClose}
          closeButton
          className="modal_title"
          style={{ height: "50px" }}
        >
          <Modal.Title id="example-custom-modal-styling-title">
            <div>
              {" "}
              <div className="heading_new_loan  ps-2">
                <h5>Service Request Details</h5>
                <div className="text_st_status ms-5">Status : </div>
                <div className="text_bolder_business_v1 ms-2">
                  Awaiting Your Response
                </div>
              </div>
              <div className=""></div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-2 admin_all_preclosure_body">
          <div className="row mt-2">
            <div className="col-lg-12">
              <div className="container p-0">
                <div className="row">
                  <div className="col ">
                    <div className="mb-3">
                      <p className="text_st ">Service type</p>
                      <span className="bolder_text ">
                        {props.data.service_type_name}
                      </span>
                    </div>
                    <div className="mb-3">
                      <p className="text_st ">Service Reference No.</p>
                      <span className="bolder_text ">
                        {props.data.service_request_reference_no}
                      </span>
                    </div>
                    <div className="mb-3">
                      <p className="text_st ">Processing Fee Payment</p>
                      <span className="bolder_text ">
                        {props.data.processing_fees_type !== undefined
                          ? props.data.processing_fees_type
                          : "-"}
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="mb-3 loan_type_servicereq">
                      <p className="text_st ">Loan Type</p>
                      <span className="bolder_text ">
                        {props.data.loan_type_name !== undefined
                          ? props.data.loan_type_name
                          : "-"}
                      </span>
                    </div>
                    <div className="mb-3">
                      <p className="text_st ">Principal Payment</p>
                      <span className="bolder_text ">
                        {props.data.principal_frequency !== undefined
                          ? props.data.principal_frequency
                          : "-"}
                      </span>
                    </div>
                    <div className="mb-3">
                      <p className="text_st ">Requested Tenure</p>
                      <span className="bolder_text ">
                        {props.data.admin_request_loan_tenure}{" "}
                        {props.data.admin_request_loan_tenure === 1
                          ? " Month"
                          : " Months"}
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="mb-3">
                      <p className="text_st ">Amount Requested</p>
                      <span className="bolder_text ">
                        {props.data.admin_request_loan_currency ==
                        LOAN_CURRENCY_TYPE_USD
                          ? "$ " + Number(props.data.loan_amount).toLocaleString()
                          : props.data.admin_request_loan_currency ==
                            LOAN_CURRENCY_TYPE_BHD
                          ? LOAN_CURRENCY_TYPE_BHD +
                            " " +
                            Number(props.data.loan_amount).toLocaleString()
                          : "-"}
                      </span>
                    </div>
                    
                    <div className="mb-3">
                      <p className="text_st ">Processing Fee</p>
                      <span className="bolder_text ">
                        {props.data.admin_request_loan_currency ==
                        LOAN_CURRENCY_TYPE_USD
                          ? "$ " + props.data.processing_fees
                          : props.data.admin_request_loan_currency ==
                            LOAN_CURRENCY_TYPE_BHD
                          ? LOAN_CURRENCY_TYPE_BHD +
                            " " +
                            props.data.processing_fees
                          : "-"}
                      </span>
                    </div>
                    <div className="mb-3 loan_pur_myserreq">
                      <p className="text_st ">Loan Purpose</p>
                      <span className="bolder_text ">
                        {props.data.loan_purpose}
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="mb-3">
                      <p className="text_st ">Monthly Interest Rate</p>
                      <span className="bolder_text ">
                        {props.data.bennefin_roi !== undefined
                          ? props.data.bennefin_roi + "%"
                          : "-"}
                      </span>
                    </div>
                    <div className="mb-3">
                      <p className="text_st ">Interest Payment</p>
                      <span className="bolder_text ">
                        {props.data.interest_frequency !== undefined
                          ? props.data.interest_frequency
                          : "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-2">
                <p className="text_st ">Notes</p>
                <div className="servreq_notes">
                    <span className="bolder_text " >
                      {props.data.notes !== "" ? props.data.notes : "-"}
                    </span>
                </div>
              </div>
              <hr />

              <div className="row bg-white my-md-1 mt-xxl-3 mb-1">
                <div className="col">
                  <ul className="nav nav-tabs d-flex tabs_height" id="myTab" role="tablist" style={{height:"40px"}}>
                    <li className="nav-item me-2" role="presentation">
                      <button
                        className="nav-link active p-1"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#home-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="home-tab-pane"
                        aria-selected="true"
                         onClick={() => setActiveTab("home-tab")}
                      >
                        <h6 className="ps-0 ">Schedule Of Return Payments</h6>
                        {activeTab === "home-tab" && (
                        <img
                          style={{ marginTop: "-48px" }}
                          src="./images/polygondown.svg"
                          alt=""
                        />
                      )}
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link p-1"
                        id="profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#profile-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="profile-tab-pane"
                        aria-selected="false"
                         onClick={() => setActiveTab("profile-tab")}
                      >
                        <h6 className="">Loan History</h6>
                        {activeTab === "profile-tab" && (
                        <img
                          style={{ marginTop: "-48px" }}
                          src="./images/polygondown.svg"
                          alt=""
                        />
                      )}
                      </button>
                    </li>
                  </ul>
                </div>

                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="home-tab-pane"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                    tabIndex="0"
                  >
                    <div className="newinvinteresttable myservicereq_table">
                    {loading ? (
                      <Skeleton width={100} height={15} />
  ) : (props.data?.payment_schedule?.length ? (
                      <Table striped className="mb-0">
                        <thead className="newinvinteresttable-headers">
                          <tr>
                            <th>Tenure Amount</th>
                            <th>Tenure Date</th>
                          </tr>
                        </thead>
                        <tbody className="newinvinttable">
                          {props.data?.payment_schedule?.map((payment) => {
                            return (
                              <tr>
                                <td>
                                  {payment.admin_request_loan_currency === LOAN_CURRENCY_TYPE_USD 
                                    ? "$ "
                                    : "BHD "}
                                  {Number(payment.tenure_amount).toLocaleString()}
                                </td>
                                <td>
                                  {moment(payment.tenure_date).format(
                                    "DD MMM YYYY"
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>) : (
      <div className="text-center fs-3 text-muted mt-5">No data found.</div>
    )
  )}
                    </div>
                  </div>
                  <div
                    className="tab-pane fade loan_history_tab loaan_history_content_styl"
                    id="profile-tab-pane"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                    tabIndex="0"
                  >
                    {loan_history_array.map((details) => {
                      return (
                        <div key={details.message} className="row pt-0">
                          <div className="style_loan">
                            <img
                              className="me-2"
                              src="./images/circle.svg"
                              alt=""
                              srcSet=""
                              height={16}
                              width={16}
                            />
                            {moment(details.created_date_time).format(
                              "ddd , D MMM YYYY"
                            )}
                          </div>
                          <div className="style_loan_txt mb-4 ms-4 pe-5">
                          {details.message}
                        </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex  ps-3 pe-3">
          <button
            className="btn btn_background mx-2 px-3 py-2"
            variant="secondary"
            onClick={handleClose}
          >
            Close
          </button>
          <button
            className="btn blue_btn mx-2 px-3 py-2"
            variant="primary"
            onClick={handleSavechanges}
          >
            I Agree Loan Terms
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ServiceRequestsTerms;
